import React  from 'react';

import I18N from '../I18N';

function mkchangesvg(cls, points) {
	return (
		<svg viewBox="0 0 16 22" width="16" height="22">
			<g transform="translate(0,5)">
				<polyline className={cls} points={points}/>
			</g>
		</svg>
	);
}

function ChangeArrow(props) {
	const pct = props.pct;
	const decimals = props.decimals || 2;
	const suffix = props.suffix || "";
	const currency_unit = props.currency_unit || false;
	const show_arrow = props.show_arrow !== undefined ? props.show_arrow : true;

	var cls;
	var svg;
	if (pct > 0) {
		cls = "ad_growth_positive";
		svg = mkchangesvg(cls, "3 8  8 0  13 8");
	} else if (pct < 0) {
		cls = "ad_growth_negative";
		svg = mkchangesvg(cls, "3 0  8 8  13 0");
	} else {
		cls = "ad_growth_zero";
		svg = mkchangesvg(cls, "3.5 3  12.5 3  12.5 6  3.5 6");
	}

	let pctText = I18N.floatval(pct, decimals);
	if(props.currency_unit) {
		pctText = I18N.floatval_unit(pct, decimals, currency_unit);
	}

	if(props.svg_only) {
		return (
			<span>{svg}</span>
		);
	}

	return (
		<span className={cls}>
			{show_arrow && <span className="pr-1">{svg}</span>}
			{pctText}{suffix}
		</span>
	);
}

export default ChangeArrow



// WEBPACK FOOTER //
// ./src/c/ChangeArrow.js